import {AuthModel, UserModel} from './_models'
import {AxiosInstance} from 'axios'

export const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
export const USER_LOCAL_STORAGE_KEY = 'kt-user-react-v'

// ===== AUTH =====
export function getAuth(): AuthModel | undefined {
  const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) return

  try {
    return JSON.parse(lsValue) as AuthModel
  } catch {
    return
  }
}

export function setAuth(auth: AuthModel) {
  localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, JSON.stringify(auth))
}

export function removeAuth() {
  localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  localStorage.removeItem(USER_LOCAL_STORAGE_KEY)
}

// ===== USER =====
export function getUser(): UserModel | undefined {
  const lsValue = localStorage.getItem(USER_LOCAL_STORAGE_KEY)
  if (!lsValue) return

  try {
    return JSON.parse(lsValue) as UserModel
  } catch {
    return
  }
}

export function setUser(user: UserModel) {
  localStorage.setItem(USER_LOCAL_STORAGE_KEY, JSON.stringify(user))
}
export function setupAxios(axios: AxiosInstance) {
  axios.interceptors.request.use(
    (config) => {
      const auth = getAuth()
      if (auth?.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`
      }
      return config
    },
    (err) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        removeAuth()

        if (!window.location.pathname.startsWith('/auth/login')) {
          window.location.href = '/auth/login'
        }
      }

      return Promise.reject(error)
    }
  )
}
